export const cmxState: CMx.CMXState = {
  feedback: null
};
